var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hidden",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wallet-solid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    gradientTransform: "rotate(45)",
    id: "Gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop2",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop3",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop4",
    offset: "92%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            .stop1 { stop-color: #FCCB00; }\n            .stop2 { stop-color: #FFFAD2; }\n            .stop3 { stop-color: #C9961A; }\n            .stop4 { stop-color: #F2DC8E; }\n            .stop5 { stop-color: #FFFAD2; }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient1)",
    d: "M448 32C465.7 32 480 46.33 480 64C480 81.67 465.7 96 448 96H80C71.16 96 64 103.2 64 112C64 120.8 71.16 128 80 128H448C483.3 128 512 156.7 512 192V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM416 336C433.7 336 448 321.7 448 304C448 286.3 433.7 272 416 272C398.3 272 384 286.3 384 304C384 321.7 398.3 336 416 336z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.af4fa229aed76d158fe3dd11a39a4aa0.svg";
export { ForwardRef as ReactComponent };